/**
 * A child's own animal, wearing their own things
 * ([Avatar](../../../docs/AVATAR.md)).
 *
 * The twenty bodies are generated from the same composition the mockups draw
 * ([D-089](../../../docs/DECISIONS.md#d-089)) — the layer order is the part that
 * is easy to get wrong, and writing it out twice is how it gets wrong in two
 * places at once. This module only fills the holes.
 */
import { AVATARS } from './avatar.generated.js';
import { dyed, wardrobeItem } from './wardrobe.js';
export * from './avatar.generated.js';
const BY_ID = new Map(AVATARS.map((one) => [one.id, one]));
/** One species by id, or undefined — a learner row can name one that has gone. */
export const avatarBody = (species) => BY_ID.get(species);
const SLOT_HOLE = {
    hat: '{HAT}',
    glasses: '{GLASSES}',
    top: '{TOP}',
    neck: '{NECK}',
    shoes: '{SHOES}',
    held: '{HELD}',
};
/**
 * The whole avatar as SVG children, ready to drop inside a `viewBox="0 0 160 240"`.
 *
 * Returns an empty string for a species that is not in the catalogue rather than
 * throwing: a saved learner row is not worth a blank screen over.
 */
export function avatarSvg(look) {
    const body = avatarBody(look.species);
    if (body === undefined)
        return '';
    let out = body.body.replaceAll('{U}', look.uid).replaceAll('{BG}', look.background);
    for (const [slot, hole] of Object.entries(SLOT_HOLE)) {
        const worn = look.loadout?.[slot] ?? null;
        // The catalogue keys items by `slot.id`; everything else keys them by `id`
        // alone, because a content id is one slug (D-086).
        const item = worn === null ? undefined : wardrobeItem(`${slot}.${worn.itemId}`);
        const drawn = item === undefined
            ? ''
            : dyed(item, worn?.dye !== null && worn?.dye !== undefined
                ? worn.dye
                : undefined);
        out = out.replaceAll(hole, drawn);
    }
    return out;
}
//# sourceMappingURL=avatar.js.map